const notificatorConstants = {
  SHOW_SUCCESS_NOTIFICATION: 'SUCCESS_NOTIFICATION',
  SHOW_ERROR_NOTIFICATION: 'ERROR_NOTIFICATION'
};

export const NOTIFICATION_TYPES = {
  EMPTY: '',
  SUCCESS: 'success',
  ERROR: 'error'
};

export default notificatorConstants;
